import { render } from "./Home.vue?vue&type=template&id=7f272adf&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=7f272adf&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__